import React from 'react';
import type { PartnerFeatureIconId } from '../content';

type IconProps = React.SVGProps<SVGSVGElement> & {
  className?: string;
};

const stroke = {
  fill: 'none' as const,
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};

function IconStorefront({ className, ...rest }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden {...stroke} {...rest}>
      <path d="M4 10.5V20h16V10.5" />
      <path d="M2.5 7.5 4 20h16l1.5-12.5" />
      <path d="M12 7.5V4.5l-3 1.5 3 1.5 3-1.5-3-1.5z" />
      <path d="M9 20v-5h6v5" />
    </svg>
  );
}

function IconMapPin({ className, ...rest }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden {...stroke} {...rest}>
      <path d="M12 21s6-5.2 6-10a6 6 0 1 0-12 0c0 4.8 6 10 6 10z" />
      <circle cx="12" cy="11" r="2.25" />
    </svg>
  );
}

function IconSparkles({ className, ...rest }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden {...stroke} {...rest}>
      <path d="M12 3.5v3M12 17.5v3M4.5 12h3M16.5 12h3" />
      <path d="m6.8 6.8 2.1 2.1M15.1 15.1l2.1 2.1M17.2 6.8l-2.1 2.1M8.9 15.1l-2.1 2.1" />
      <path d="M12 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7z" />
    </svg>
  );
}

function IconChart({ className, ...rest }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden {...stroke} {...rest}>
      <path d="M4.5 19.5h15" />
      <path d="M7.5 16.5V11M12 16.5V7.5M16.5 16.5v-4" />
    </svg>
  );
}

function IconShieldLock({ className, ...rest }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden {...stroke} {...rest}>
      <path d="M12 22s7-3.5 7-9V6l-7-3-7 3v7c0 5.5 7 9 7 9z" />
      <path d="M10 11.5a2 2 0 1 1 4 0v1.5H10V11.5z" />
      <path d="M10 13h4v2.5H10V13z" />
    </svg>
  );
}

const ICONS: Record<PartnerFeatureIconId, React.FC<IconProps>> = {
  profile: IconStorefront,
  map: IconMapPin,
  recommend: IconSparkles,
  analytics: IconChart,
  exclusivity: IconShieldLock,
};

interface PartnersFeatureIconProps {
  id: PartnerFeatureIconId;
}

const PartnersFeatureIcon: React.FC<PartnersFeatureIconProps> = ({ id }) => {
  const Icon = ICONS[id];

  return (
    <div
      className="flex size-11 shrink-0 items-center justify-center rounded-2xl bg-[rgba(235,66,178,0.1)]"
      aria-hidden
    >
      <Icon className="size-5 text-chisme-primary" />
    </div>
  );
};

export default PartnersFeatureIcon;
